import React from "react";
import { fetchFoundingSpots } from "../lib/api";
import FoundingForm from "./FoundingForm";

function Benefit({ title, body }) {
  return (
    <li className="flex items-start gap-4">
      <span className="mt-2 inline-block w-6 h-px bg-[#E07B3A] flex-shrink-0" />
      <div>
        <p className="font-sans-tight font-bold text-[1.12rem] tracking-tight">
          {title}
        </p>
        <p className="font-serif-body text-[#4A4A4A] mt-1 text-[1rem] leading-relaxed">
          {body}
        </p>
      </div>
    </li>
  );
}

export default function FoundingCustomerSection({ defaultTrade }) {
  const [spots, setSpots] = React.useState(null);
  React.useEffect(() => {
    fetchFoundingSpots()
      .then(setSpots)
      .catch(() => setSpots(null));
  }, []);

  return (
    <section id="founding" data-testid="founding-section" className="bg-[#FAF7F2] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="kicker">Founding customer program</p>
            <h2 className="h-section text-[clamp(2rem,4.2vw,3.4rem)] mt-5">
              First 50 customers lock in half price.
            </h2>

            <ul className="mt-10 space-y-6 max-w-md">
              <Benefit
                title="50% off year one"
                body="Locked in for 12 months. No price-creep at renewal."
              />
              <Benefit
                title="14-day shadow mode"
                body="We watch and draft. You don't pay a cent until you've read drafts you'd actually send."
              />
              <Benefit
                title="Direct line to the team"
                body="You get a Slack channel with the agents building the next 30 recipes. Tell us what's broken. We ship the fix."
              />
            </ul>

            {spots?.open && (
              <p
                className="mt-10 font-mono-spec text-[13px] text-[#0B3D5C]"
                data-testid="founding-spots-counter"
              >
                {spots.remaining} of {spots.total} founding spots remaining.
              </p>
            )}
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <FoundingForm defaultTrade={defaultTrade} />
          </div>
        </div>
      </div>
    </section>
  );
}
